import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Pings the backend `/api/` root once on mount so we surface obvious
 * connectivity issues in the console during development. Silent-fails.
 *
 * Extracted from App.js to keep the top-level shell focused on layout.
 */
export function useBackendHealthPing() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/`);
        if (!cancelled) {
          // eslint-disable-next-line no-console
          console.log(r.data.message);
        }
      } catch (e) {
        if (!cancelled) {
          // eslint-disable-next-line no-console
          console.error(e, 'errored out requesting / api');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
}
